/* Mottakerregister for Build-decket: merkevarefarge (deckets eneste aksent), sceneplate (03), Build Lab-navn og «Why»-punkter.
   Logoene ligger i det felles registeret (../headliner/brands.js). Ukjent navn → tekst-wordmark og deckets egen aksent. */
import { logoOf, Wordmark } from "../headliner/brands";

export { Wordmark };

/* «Why X» — strategisk, ikke produktbeskrivelse (brukerens review fra Lovable-stolen): hvorfor akkurat dette rommet er interessant for X.
   Punkt 2 bærer merkevarens egen tese; resten er felles. */
const WHY = (name, shift) => [
  ["The audience is the opportunity", `The people in the room know the problems. ${name} gives them the ability to build the solution.`],
  ["From approval to creation", shift],
  ["Production, not theatre", "The build ends as working software — not a slide, a mock-up or an AI demo."],
  [`A category ${name} can own`, "The summit gives one platform the story of turning business ideas into software. Exclusively, on the main stage and in the room."],
];
const GENERIC_SHIFT = "Executives and operators no longer only approve software projects — they can prototype and shape them themselves.";

export const BRANDS = {
  lovable: {
    color: "#ff66f4",
    plate: "/images/build-stage-lovable.webp",
    lab: "The Build Lab by Lovable",
    why: (n) => WHY(n, "Whole teams — product, design, operations — build together, from first prototype to production-ready software. Executives stop only approving software projects; they shape them."),
  },
  replit: {
    color: "#ff3c00",
    plate: "/images/build-stage-replit.webp",
    lab: "The Build Lab — powered by Replit",
    why: (n) => WHY(n, "From prompt to deployed software with agents doing the work — building, hosting and running in one place. Executives stop only approving software projects; they shape them."),
  },
  emergent: {
    color: "#055ffa",
    plate: "/images/build-stage-emergent.webp",
    lab: "The Build Lab by Emergent",
    why: (n) => WHY(n, "Full-stack products built by agents from a plain-language description — one workflow from first idea to a running product. Executives stop only approving software projects; they shape them."),
  },
  base44: {
    color: "#ff6a00",
    plate: "/images/build-stage-base44.webp",
    lab: "The Build Lab by Base44",
    why: (n) => WHY(n, "Fully working software — database, logins and hosting included — from a plain-language description, in minutes. Executives stop only approving software projects; they shape them."),
  },
};

export const brandOf = (name) => {
  const b = BRANDS[(name || "").trim().toLowerCase()];
  return { name, color: null, plate: "/images/build-stage.webp", lab: `The Build Lab by ${name}`, why: (n) => WHY(n, GENERIC_SHIFT), logo: logoOf(name), ...b };
};

/* Merkevarefargen som deckets aksent (erstatter gul) når mottakeren er kjent */
export const brandRootStyle = (name) => {
  const b = brandOf(name);
  return b.color ? { "--hd-gul": b.color, "--bd-brand": b.color } : undefined;
};
